<template>
    <b-modal
        v-if="document_folder"
        :id="id"
        :title="'Are you sure you want to delete ' + document_folder.name + '?'"
        size="lg"
    >
        <p>By deleting this folder you will be deleting all of its documents and sub-folders.</p>
        <template v-slot:modal-footer>
            <b-button-group>
                <b-button variant="outline-dark" squared @click="$bvModal.hide(id)">No</b-button>
                <b-button variant="outline-danger" squared @click="deleteFolder">Yes</b-button>
            </b-button-group>
        </template>
    </b-modal>
</template>

<script>
  import ToastNotifications from "../shared/mixins/ToastNotifications";
  import DocumentFolder from "../../models/DocumentFolder";

  export default {
    name: 'DocumentFolderDeleteModal',
    components: {},
    props: {
      document_folder: {
        default: function () {
          return null;
        }
      },
      id: {
        default: function () {
          return 'document-folder-delete-modal-' + Date.now();
        }
      },
    },
    mixins: [ToastNotifications],
    methods: {
      deleteFolder() {
        const id = this.document_folder.id;
        return DocumentFolder.api().remove(id).then(() => {
          this.quickSuccessToast('Folder was deleted', 'You will be redirected to the main management page.');
          DocumentFolder.delete(id);
          this.$emit('onDelete');
        });
      }
    }
  }
</script>